import { clickEvent } from 'utils/adaConfigurations/customEvents';

// Constants
import { APP_FLOW } from 'constants/appFlow';

const { LOG_ME_IN } = APP_FLOW;

const nsInputField = 'input-field';
const nsContentFooter = 'content-footer';

export const REVIEW_PAGE_ADA = [
  {
    cssName: 'dealer-info__street',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'icon icon-arrow__back button-header__icon',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'visible button-header button-header__cart',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'visible button-header button-header__cta-services',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'sidebar-button',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'contact-info',
    eventName: null,
    eventFn: null,
    intlStr: {
      id: 'c8.aria.review.page.contact.info',
      defaultMessage: 'please enter or review contact information'
    }
  },
  {
    cssName: `${nsInputField}__input firstName_input`,
    eventName: null,
    eventFn: null,
    intlStr: {
      id: 'c8.aria.review.page.first.name',
      defaultMessage: 'First Name'
    }
  },
  {
    cssName: `${nsInputField}__input lastName_input`,
    eventName: null,
    eventFn: null,
    intlStr: {
      id: 'c8.aria.review.page.last.name',
      defaultMessage: 'Last Name'
    }
  },
  {
    cssName: `${nsInputField}__input phone_input`,
    eventName: null,
    eventFn: null,
    intlStr: {
      id: 'c8.aria.review.page.phone.number',
      defaultMessage: 'Phone number'
    }
  },
  {
    cssName: `${nsInputField}__input email_input`,
    eventName: null,
    eventFn: null,
    intlStr: {
      id: 'c8.aria.review.page.email.address',
      defaultMessage: 'Email Address'
    }
  },
  {
    cssName: 'review-page__info-missing',
    eventName: null,
    eventFn: null
  },
  {
    cssName: 'reminders row',
    eventName: null,
    eventFn: null,
    intlStr: {
      id: 'c8.aria.reminder.and.update.settings',
      defaultMessage: 'Reminder and update settings'
    }
  },
  {
    cssName: 'review-page__review-panel-row',
    eventName: null,
    eventFn: null,
    intlStr: {
      id: 'c8.aria.review.selections',
      defaultMessage: 'Review selections'
    }
  },
  {
    cssName: 'additional-questions',
    eventName: null,
    eventFn: null,
    intlStr: {
      id: 'c8.aria.review.page.additional.comments',
      defaultMessage: 'Additional Comments'
    }
  },
  {
    cssName: 'questions-area__textarea',
    eventName: null,
    eventFn: null,
    intlStr: {
      id: 'c8.aria.review.page.additional.comments',
      defaultMessage: 'Additional Comments'
    }
  },
  {
    cssName: 'footer_container',
    eventName: null,
    eventFn: null,
    intlStr: {
      id: 'c8.aria.footer',
      defaultMessage: 'Footer'
    }
  },
  {
    cssName: `${nsContentFooter}__xtime-logo`,
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'footer-privacy__button',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'footer-terms__button',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: `button button--link ${nsContentFooter}__change-language-button`,
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'field-switch text',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'field-switch email',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'reminders__info-missing',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'review-page__info-right',
    eventName: 'keyup',
    eventFn: clickEvent,
    intlStr: {
      id: 'c8.aria.open.cart',
      defaultMessage: 'Open cart'
    }
  },
  {
    cssName: 'review-page__info-right promo-in-range',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'appointment-flow-footer__continue-button',
    eventName: 'keyup',
    eventFn: clickEvent
  }
];

const REVIEW_PAGE_ORDER = [
  'dealer-info__street',
  'icon icon-arrow__back button-header__icon',
  'visible button-header button-header__cart',
  'visible button-header button-header__cta-services',
  'sidebar-button',
  'contact-info',
  `${nsInputField}__input firstName_input`,
  `${nsInputField}__input lastName_input`,
  `${nsInputField}__input phone_input`,
  `${nsInputField}__input email_input`,
  'review-page__info-missing',
  'reminders row',
  'field-switch text',
  'field-switch email',
  'reminder__info-missing',
  'review-page__review-panel-row',
  'review-page__info-right',
  'review-page__info-right promo-in-range',
  'appointment-flow-footer__continue-button',
  'additional-questions',
  'questions-area__textarea',
  'footer_container',
  `${nsContentFooter}__xtime-logo`,
  'footer-privacy__button',
  'footer-terms__button',
  `button button--link ${nsContentFooter}__change-language-button`
];

export const REVIEW_PAGE_TAB_ELEMENTS = [];

export const getTabElements = appFlow => {
  let elementIndex;
  let htmlTag;

  REVIEW_PAGE_ORDER.forEach(elementCss => {
    htmlTag = document.getElementsByClassName(elementCss)[0];
    if (htmlTag) {
      elementIndex = elementCss.indexOf(`${nsInputField}__input`);
      if (appFlow === LOG_ME_IN && elementIndex === -1) {
        REVIEW_PAGE_TAB_ELEMENTS.push(elementCss);
      } else if (appFlow !== LOG_ME_IN) {
        REVIEW_PAGE_TAB_ELEMENTS.push(elementCss);
      }
    }
  });

  return REVIEW_PAGE_TAB_ELEMENTS;
};

export const assignADA = (listElements, intl) => {
  listElements.forEach(adaElement => {
    const htmlTag = document.getElementsByClassName(adaElement.cssName)[0];
    if (htmlTag) {
      htmlTag.setAttribute('tabindex', '0');
      if (adaElement.intlStr) {
        htmlTag.setAttribute(
          'aria-label',
          intl.formatMessage({
            id: adaElement.intlStr.id,
            defaultMessage: adaElement.intlStr.defaultMessage
          })
        );
      }
      if (adaElement.eventName && adaElement.eventFn) {
        htmlTag.addEventListener(
          adaElement.eventName,
          adaElement.eventFn.bind(htmlTag),
          false
        );
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/utils/adaConfigurations/ReviewPageADA.js